(function () {
  var SECTION_SELECTOR = '.oddit-cart-drawer';
  var sectionState = new Map();
  /* Tracks portaled drawers by section id so we can find and remove them when
     Shopify's editor fires `shopify:section:unload` (which targets the empty
     `<div id="shopify-section-XXX">` wrapper, not the drawer in <body>). */
  var portaledDrawers = new Map();

  function isThemeEditor() {
    return typeof window.Shopify !== 'undefined' && window.Shopify.designMode === true;
  }

  function initSection(section) {
    /* Portal the drawer to <body> so it escapes any ancestor stacking context
       (e.g. transformed/filtered wrappers around the header group) and renders
       above the sticky header. Skip the page variant (`oddit-cart-drawer--page`)
       used by the standalone /cart template — that one is rendered in-place
       inside its own section wrapper. */
    var isPageVariant = section.classList.contains('oddit-cart-drawer--page');
    if (!isPageVariant && section.parentElement !== document.body) {
      document.body.appendChild(section);
      if (section.id) {
        portaledDrawers.set(section.id, section);
      }
    }

    var state = {
      panel: section.querySelector('.oddit-cart-drawer__panel'),
      overlay: section.querySelector('.oddit-cart-drawer__overlay'),
      closeBtn: section.querySelector('.oddit-cart-drawer__close'),
      track: section.querySelector('.oddit-cart-drawer__recommendations-track'),
      progressFill: section.querySelector('.oddit-cart-drawer__progress-fill'),
      trapHandler: null
    };

    sectionState.set(section, state);

    function onCloseClick() {
      closeDrawer(section);
    }

    function onOverlayClick() {
      closeDrawer(section);
    }

    function onKeydown(e) {
      if (e.key === 'Escape') {
        closeDrawer(section);
      }
    }

    function onDelegatedClick(e) {
      var qtyBtn = e.target.closest('.oddit-cart-drawer__quantity-btn');
      if (qtyBtn) {
        handleQuantityChange(qtyBtn);
      }

      var removeBtn = e.target.closest('.oddit-cart-drawer__item-remove');
      if (removeBtn) {
        handleRemoveItem(removeBtn);
      }

      var quickAddTrigger = e.target.closest('[data-quick-add-trigger]');
      if (quickAddTrigger) {
        openQuickAddModal(section, quickAddTrigger);
      }

      var quickAddClose = e.target.closest('[data-quick-add-close]');
      if (quickAddClose) {
        closeQuickAddModal(section);
      }

      var engravingTrigger = e.target.closest('[data-engraving-trigger]');
      if (engravingTrigger) {
        openEngravingModal(section, engravingTrigger);
      }

      var engravingClose = e.target.closest('[data-engraving-close]');
      if (engravingClose) {
        closeEngravingModal(section);
      }
    }

    function onTrackScroll() {
      updateProgressBar(state.track, state.progressFill);
    }

    if (state.closeBtn) {
      state.closeBtn.addEventListener('click', onCloseClick);
    }

    if (state.overlay) {
      state.overlay.addEventListener('click', onOverlayClick);
    }

    section.addEventListener('keydown', onKeydown);
    section.addEventListener('click', onDelegatedClick);

    if (state.track) {
      updateProgressBar(state.track, state.progressFill);
      state.track.addEventListener('scroll', onTrackScroll, { passive: true });
    }

    state._handlers = {
      onCloseClick: onCloseClick,
      onOverlayClick: onOverlayClick,
      onKeydown: onKeydown,
      onDelegatedClick: onDelegatedClick,
      onTrackScroll: onTrackScroll
    };
  }

  function openDrawer(section) {
    section.style.display = '';
    document.body.style.overflow = 'hidden';

    /* Force reflow so the panel paints at translateX(100%)
       before is-open transitions it to translateX(0). */
    void section.offsetHeight;

    requestAnimationFrame(function () {
      section.classList.add('is-open');

      var state = sectionState.get(section);
      if (state && state.closeBtn) {
        requestAnimationFrame(function () {
          state.closeBtn.focus();
          if (state.track) {
            updateProgressBar(state.track, state.progressFill);
          }
        });
      }
    });

    trapFocus(section);
  }

  function closeDrawer(section) {
    section.classList.remove('is-open');
    document.body.style.overflow = '';

    var state = sectionState.get(section);

    // Remove trap focus handler
    if (state && state.trapHandler) {
      section.removeEventListener('keydown', state.trapHandler);
      state.trapHandler = null;
    }

    if (state && state.panel) {
      state.panel.addEventListener('transitionend', function handler() {
        state.panel.removeEventListener('transitionend', handler);
        if (!section.classList.contains('is-open')) {
          section.style.display = 'none';
        }
      }, { once: true });
    }
  }

  function trapFocus(section) {
    var state = sectionState.get(section);

    // Remove previous trap handler if any
    if (state && state.trapHandler) {
      section.removeEventListener('keydown', state.trapHandler);
    }

    var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

    function handleTab(e) {
      if (e.key !== 'Tab') return;
      if (!section.classList.contains('is-open')) {
        section.removeEventListener('keydown', handleTab);
        if (state) state.trapHandler = null;
        return;
      }

      var focusableElements = section.querySelectorAll(focusableSelector);
      if (focusableElements.length === 0) return;

      var first = focusableElements[0];
      var last = focusableElements[focusableElements.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    section.addEventListener('keydown', handleTab);
    if (state) state.trapHandler = handleTab;
  }

  function handleQuantityChange(btn) {
    if (btn.disabled) return;
    var quantityWrap = btn.closest('.oddit-cart-drawer__quantity');
    if (!quantityWrap) return;

    var valueEl = quantityWrap.querySelector('.oddit-cart-drawer__quantity-value');
    if (!valueEl) return;

    var lineIndex = parseInt(btn.getAttribute('data-line-index'), 10);
    if (!lineIndex) return;

    var item = btn.closest('.oddit-cart-drawer__item');
    var current = parseInt(valueEl.textContent, 10) || 1;
    var isDecrease = btn.hasAttribute('data-quantity-minus');
    var next = isDecrease ? current - 1 : current + 1;
    if (next < 0) return;

    var section = btn.closest('.oddit-cart-drawer');
    setLineItemBusy(btn, true);
    clearLineItemError(item);
    valueEl.textContent = next;

    changeCartLine(lineIndex, next)
      .then(function () { return syncChildEngravings(); })
      .then(function () { return refreshCartDrawer(section); })
      .catch(function (err) {
        valueEl.textContent = current;
        showLineItemError(item, (err && err.message) || 'Could not update quantity.');
      })
      .then(function () { setLineItemBusy(btn, false); });
  }

  function handleRemoveItem(btn) {
    if (btn.disabled) return;
    var item = btn.closest('.oddit-cart-drawer__item');
    var lineIndex = parseInt(btn.getAttribute('data-line-index'), 10);
    if (!item || !lineIndex) return;

    var section = btn.closest('.oddit-cart-drawer');
    item.style.opacity = '0.4';
    item.style.transition = 'opacity 0.2s ease';
    setLineItemBusy(btn, true);

    changeCartLine(lineIndex, 0)
      .then(function () { return syncChildEngravings(); })
      .then(function () { return refreshCartDrawer(section); })
      .catch(function () {
        item.style.opacity = '';
        setLineItemBusy(btn, false);
      });
  }

  function setLineItemBusy(btn, busy) {
    var item = btn.closest('.oddit-cart-drawer__item');
    if (!item) return;
    item.querySelectorAll('button').forEach(function (b) {
      b.disabled = busy;
    });
  }

  function changeCartLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (res) {
      return res.json().then(function (body) {
        if (!res.ok) {
          throw new Error((body && (body.description || body.message)) || 'Cart change failed');
        }
        return body;
      });
    }).then(function (cart) {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      return cart;
    });
  }

  function showLineItemError(item, message) {
    if (!item || !message) return;
    var existing = item.querySelector('[data-line-item-error]');
    if (existing) existing.remove();
    var err = document.createElement('p');
    err.className = 'oddit-cart-drawer__item-error';
    err.setAttribute('data-line-item-error', '');
    err.setAttribute('role', 'alert');
    err.textContent = message;
    item.appendChild(err);
    setTimeout(function () {
      if (err.parentNode === item) err.remove();
    }, 5000);
  }

  function clearLineItemError(item) {
    if (!item) return;
    var existing = item.querySelector('[data-line-item-error]');
    if (existing) existing.remove();
  }

  function updateProgressBar(track, fill) {
    if (!track || !fill) return;

    if (track.clientWidth === 0) return;

    var scrollable = track.scrollWidth - track.clientWidth;
    var minPercent = 35;

    if (scrollable <= 0) {
      fill.style.width = '100%';
      return;
    }

    var progress = track.scrollLeft / scrollable;
    var fillPercent = minPercent + (progress * (100 - minPercent));
    fill.style.width = fillPercent + '%';
  }

  function destroySection(section) {
    var state = sectionState.get(section);
    if (state) {
      var handlers = state._handlers;
      if (handlers) {
        if (state.closeBtn) state.closeBtn.removeEventListener('click', handlers.onCloseClick);
        if (state.overlay) state.overlay.removeEventListener('click', handlers.onOverlayClick);
        section.removeEventListener('keydown', handlers.onKeydown);
        section.removeEventListener('click', handlers.onDelegatedClick);
        if (state.track) state.track.removeEventListener('scroll', handlers.onTrackScroll);
      }
      if (state.trapHandler) {
        section.removeEventListener('keydown', state.trapHandler);
      }
    }
    sectionState.delete(section);
  }

  /* ── Quick Add modal ── */

  function openQuickAddModal(section, trigger) {
    var modal = section.querySelector('[data-quick-add-modal]');
    if (!modal) return;
    var content = modal.querySelector('[data-quick-add-content]');
    var handle = trigger.getAttribute('data-product-handle');
    if (!content || !handle) return;

    content.innerHTML = '<p class="oddit-cart-drawer__quick-add-loading">Loading…</p>';
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');

    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (product) {
        renderQuickAddProduct(content, product);
      })
      .catch(function () {
        content.innerHTML = '<p class="oddit-cart-drawer__quick-add-loading">Couldn\'t load product. Please try again.</p>';
      });
  }

  function closeQuickAddModal(section) {
    var modal = section.querySelector('[data-quick-add-modal]');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');

    // If we revealed the section solely to host the modal (drawer never
    // opened), tear that state down so the section returns to display:none.
    if (section.classList.contains('is-quick-add-only')) {
      section.classList.remove('is-quick-add-only');
      if (!section.classList.contains('is-open')) {
        section.style.display = 'none';
      }
    }
  }

  function renderQuickAddProduct(content, product) {
    var firstAvailable = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) {
        firstAvailable = product.variants[i];
        break;
      }
    }
    var selectedVariant = firstAvailable || product.variants[0];
    var selectedOptions = selectedVariant.options.slice();

    content.innerHTML = '';

    /* Header: image + title + price */
    var header = document.createElement('div');
    header.className = 'oddit-cart-drawer__quick-add-product';

    var imgEl = null;
    var initialImageSrc = variantImageSrc(selectedVariant) || product.featured_image || '';
    if (initialImageSrc) {
      var imgWrap = document.createElement('div');
      imgWrap.className = 'oddit-cart-drawer__quick-add-image';
      imgEl = document.createElement('img');
      imgEl.src = initialImageSrc;
      imgEl.alt = product.title;
      imgEl.setAttribute('data-quick-add-image', '');
      imgWrap.appendChild(imgEl);
      header.appendChild(imgWrap);
    }

    var info = document.createElement('div');
    info.className = 'oddit-cart-drawer__quick-add-info';

    var titleEl = document.createElement('h3');
    titleEl.className = 'oddit-cart-drawer__quick-add-title';
    titleEl.textContent = product.title;
    info.appendChild(titleEl);

    var priceEl = document.createElement('p');
    priceEl.className = 'oddit-cart-drawer__quick-add-price';
    priceEl.textContent = formatMoney(selectedVariant.price);
    priceEl.setAttribute('data-quick-add-price', '');
    info.appendChild(priceEl);

    header.appendChild(info);
    content.appendChild(header);

    /* Option selectors */
    var optionsContainer = document.createElement('div');
    optionsContainer.className = 'oddit-cart-drawer__quick-add-options';
    optionsContainer.style.display = 'flex';
    optionsContainer.style.flexDirection = 'column';
    optionsContainer.style.gap = '12px';

    /* Buttons grouped by option index so we can recompute availability after each pick. */
    var buttonsByOption = [];

    product.options.forEach(function (option, optionIdx) {
      var optionName = typeof option === 'string' ? option : option.name;
      var optionRow = document.createElement('div');
      optionRow.className = 'oddit-cart-drawer__quick-add-option';

      var label = document.createElement('div');
      label.className = 'oddit-cart-drawer__quick-add-option-label';

      var labelName = document.createElement('span');
      labelName.className = 'oddit-cart-drawer__quick-add-option-label-name';
      labelName.textContent = optionName + ':';
      label.appendChild(labelName);

      var labelValue = document.createElement('span');
      labelValue.className = 'oddit-cart-drawer__quick-add-option-label-value';
      labelValue.textContent = selectedOptions[optionIdx] || '';
      label.appendChild(labelValue);

      optionRow.appendChild(label);

      var values = document.createElement('div');
      values.className = 'oddit-cart-drawer__quick-add-option-values';

      var uniqueValues = [];
      product.variants.forEach(function (v) {
        var val = v.options[optionIdx];
        if (uniqueValues.indexOf(val) === -1) uniqueValues.push(val);
      });

      var optionButtons = [];

      uniqueValues.forEach(function (value) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'oddit-cart-drawer__quick-add-option-value';
        btn.textContent = value;
        btn.setAttribute('data-option-index', optionIdx);
        btn.setAttribute('data-option-value', value);
        if (value === selectedOptions[optionIdx]) btn.classList.add('is-selected');
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          selectedOptions[optionIdx] = value;
          labelValue.textContent = value;
          var match = findVariantByOptions(product.variants, selectedOptions);
          if (match) {
            selectedVariant = match;
            priceEl.textContent = formatMoney(match.price);
            if (imgEl) {
              var newSrc = variantImageSrc(match) || product.featured_image;
              if (newSrc) imgEl.src = newSrc;
            }
          } else {
            selectedVariant = null;
          }
          /* Update is-selected state for this option */
          var siblings = values.querySelectorAll('.oddit-cart-drawer__quick-add-option-value');
          for (var s = 0; s < siblings.length; s++) {
            siblings[s].classList.remove('is-selected');
          }
          btn.classList.add('is-selected');
          updateAvailability();
          updateSubmitState();
        });
        values.appendChild(btn);
        optionButtons.push({ btn: btn, value: value });
      });

      buttonsByOption.push({ optionIdx: optionIdx, buttons: optionButtons });

      optionRow.appendChild(values);
      optionsContainer.appendChild(optionRow);
    });

    content.appendChild(optionsContainer);

    /* Submit */
    var submit = document.createElement('button');
    submit.type = 'button';
    submit.className = 'oddit-cart-drawer__quick-add-submit';
    submit.textContent = 'Add to Cart';
    submit.addEventListener('click', function () {
      if (submit.disabled || !selectedVariant) return;
      submit.disabled = true;
      submit.textContent = 'Adding…';
      var section = content.closest('.oddit-cart-drawer');
      addVariantToCart(selectedVariant.id)
        .then(function () {
          submit.textContent = 'Added!';
          return refreshCartDrawer(section);
        })
        .then(function () {
          if (!section.classList.contains('is-open')) {
            openDrawer(section);
          }
          setTimeout(function () { closeQuickAddModal(section); }, 600);
        })
        .catch(function () {
          submit.disabled = false;
          submit.textContent = 'Try Again';
        });
    });
    content.appendChild(submit);

    function updateAvailability() {
      buttonsByOption.forEach(function (group) {
        group.buttons.forEach(function (entry) {
          var available = isOptionValueAvailable(product.variants, group.optionIdx, entry.value, selectedOptions);
          entry.btn.disabled = !available;
          entry.btn.classList.toggle('is-unavailable', !available);
        });
      });
    }

    function updateSubmitState() {
      var soldOut = !selectedVariant || !selectedVariant.available;
      submit.disabled = soldOut;
      submit.classList.toggle('is-sold-out', soldOut);
      submit.textContent = soldOut ? 'Sold Out' : 'Add to Cart';
    }

    updateAvailability();
    updateSubmitState();
  }

  /* ── Engraving modal ── */

  var ENGRAVING_FONTS = ['Helvetica', 'Stanislav', 'Tungsten', 'Telegraphem'];
  var ENGRAVING_FONT_FAMILIES = {
    'Helvetica':   "'Helvetica-Engraving', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    'Stanislav':   "'Stanislav-Engraving', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    'Tungsten':    "'Tungsten-Engraving', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    'Telegraphem': "'Telegraphem-Engraving', 'Helvetica Neue', Helvetica, Arial, sans-serif"
  };

  function getEngravingFontAssets(section) {
    var script = section.querySelector('script[data-engraving-fonts]');
    if (!script) return {};
    try { return JSON.parse(script.textContent); } catch (e) { return {}; }
  }

  function openEngravingModal(section, trigger) {
    var modal = section.querySelector('[data-engraving-modal]');
    var content = modal && modal.querySelector('[data-engraving-content]');
    if (!modal || !content) return;

    var engravingHandle = trigger.getAttribute('data-engraving-handle');
    var engravingVariantId = parseInt(trigger.getAttribute('data-engraving-variant-id'), 10);
    var engravingTitle = trigger.getAttribute('data-engraving-title');
    var engravingPrice = trigger.getAttribute('data-engraving-price') || '';
    var parentTitle = trigger.getAttribute('data-parent-product-title');
    var lineIndex = parseInt(trigger.getAttribute('data-line-index'), 10);
    var lineQuantity = parseInt(trigger.getAttribute('data-line-quantity'), 10) || 1;
    var isApplied = trigger.classList.contains('is-applied');
    if (!engravingHandle || !engravingVariantId) return;

    content.innerHTML = '<p class="oddit-cart-drawer__quick-add-loading">Loading…</p>';
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');

    var fontAssets = getEngravingFontAssets(section);

    Promise.all([
      fetch('/products/' + engravingHandle + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }),
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
    ])
      .then(function (results) {
        renderEngravingForm(section, content, {
          product: results[0],
          cart: results[1],
          parentTitle: parentTitle,
          parentLineIndex: lineIndex,
          parentLineQuantity: lineQuantity,
          engravingVariantId: engravingVariantId,
          engravingTitle: engravingTitle,
          engravingPrice: engravingPrice,
          fontAssets: fontAssets,
          isApplied: isApplied
        });
      })
      .catch(function () {
        content.innerHTML = '<p class="oddit-cart-drawer__quick-add-loading">Couldn\'t load engraving options. Please try again.</p>';
      });
  }

  function closeEngravingModal(section) {
    var modal = section.querySelector('[data-engraving-modal]');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
  }

  function renderEngravingForm(section, content, ctx) {
    /* Read existing engraving values from the parent line's properties. */
    var parentLine = ctx.cart && ctx.cart.items && ctx.cart.items[ctx.parentLineIndex - 1];
    var parentProps = (parentLine && parentLine.properties) || {};

    var orientation = parentProps['-Orientation'] || 'Right Handed';
    var font = parentProps['-Font selection'] || 'Helvetica';
    var text = parentProps['-Engraving text'] || '';

    content.innerHTML = '';

    /* Preview row */
    var preview = document.createElement('div');
    preview.className = 'oddit-cart-drawer__engraving-preview';
    if (ctx.product.featured_image) {
      var imgWrap = document.createElement('div');
      imgWrap.className = 'oddit-cart-drawer__engraving-preview-image';
      var img = document.createElement('img');
      img.src = ctx.product.featured_image;
      img.alt = ctx.product.title;
      imgWrap.appendChild(img);
      preview.appendChild(imgWrap);
    }

    var previewBody = document.createElement('div');
    previewBody.className = 'oddit-cart-drawer__engraving-preview-body';
    var orientationSection = buildOrientationSection(orientation, function (val) { orientation = val; });
    previewBody.appendChild(orientationSection);
    preview.appendChild(previewBody);
    content.appendChild(preview);

    /* Custom text section */
    var textSection = document.createElement('div');
    textSection.className = 'oddit-cart-drawer__engraving-section';

    var textLabel = document.createElement('div');
    textLabel.className = 'oddit-cart-drawer__engraving-section-label';
    var textLabelName = document.createElement('span');
    textLabelName.className = 'oddit-cart-drawer__engraving-section-label-name';
    textLabelName.textContent = 'Custom text*';
    var textLabelAux = document.createElement('span');
    textLabelAux.className = 'oddit-cart-drawer__engraving-section-label-aux';
    textLabelAux.textContent = '(max 20 characters)';
    textLabel.appendChild(textLabelName);
    textLabel.appendChild(textLabelAux);
    textSection.appendChild(textLabel);

    var textInput = document.createElement('input');
    textInput.type = 'text';
    textInput.className = 'oddit-cart-drawer__engraving-text-input';
    textInput.placeholder = 'Enter your text here';
    textInput.maxLength = 20;
    textInput.value = text;
    textInput.setAttribute('data-engraving-text-input', '');
    if (ENGRAVING_FONT_FAMILIES[font]) {
      textInput.style.fontFamily = ENGRAVING_FONT_FAMILIES[font];
    }
    textSection.appendChild(textInput);

    var textHelp = document.createElement('p');
    textHelp.className = 'oddit-cart-drawer__engraving-help';
    textHelp.textContent = 'One line only. No symbols or emojis.';
    textSection.appendChild(textHelp);

    content.appendChild(textSection);

    /* Font section */
    var fontSection = document.createElement('div');
    fontSection.className = 'oddit-cart-drawer__engraving-section';

    var fontLabel = document.createElement('div');
    fontLabel.className = 'oddit-cart-drawer__engraving-section-label';
    var fontLabelName = document.createElement('span');
    fontLabelName.className = 'oddit-cart-drawer__engraving-section-label-name';
    fontLabelName.textContent = 'Choose a font*';
    fontLabel.appendChild(fontLabelName);
    fontSection.appendChild(fontLabel);

    var fontGrid = document.createElement('div');
    fontGrid.className = 'oddit-cart-drawer__engraving-fonts';

    ENGRAVING_FONTS.forEach(function (fontName) {
      var card = document.createElement('button');
      card.type = 'button';
      card.className = 'oddit-cart-drawer__engraving-font';
      card.setAttribute('data-engraving-font', fontName);
      if (fontName === font) card.classList.add('is-selected');

      if (ctx.fontAssets[fontName]) {
        var fontImg = document.createElement('img');
        fontImg.className = 'oddit-cart-drawer__engraving-font-image';
        fontImg.src = ctx.fontAssets[fontName];
        fontImg.alt = '';
        card.appendChild(fontImg);
      }

      var fontText = document.createElement('span');
      fontText.className = 'oddit-cart-drawer__engraving-font-name';
      fontText.textContent = fontName;
      card.appendChild(fontText);

      card.addEventListener('click', function () {
        font = fontName;
        fontGrid.querySelectorAll('.oddit-cart-drawer__engraving-font').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        card.classList.add('is-selected');
        if (ENGRAVING_FONT_FAMILIES[fontName]) {
          textInput.style.fontFamily = ENGRAVING_FONT_FAMILIES[fontName];
        }
      });

      fontGrid.appendChild(card);
    });

    fontSection.appendChild(fontGrid);
    content.appendChild(fontSection);

    /* Error placeholder */
    var errorEl = document.createElement('p');
    errorEl.className = 'oddit-cart-drawer__engraving-error';
    errorEl.style.display = 'none';
    content.appendChild(errorEl);

    /* Actions */
    var actions = document.createElement('div');
    actions.className = 'oddit-cart-drawer__engraving-actions';

    var apply = document.createElement('button');
    apply.type = 'button';
    apply.className = 'oddit-cart-drawer__engraving-apply';
    apply.textContent = ctx.isApplied ? 'Update Engraving' : 'Apply Engraving';
    apply.addEventListener('click', function () {
      var value = textInput.value.trim();
      if (!value) {
        errorEl.textContent = 'Please enter the text you want engraved.';
        errorEl.style.display = '';
        textInput.focus();
        return;
      }
      errorEl.style.display = 'none';
      apply.disabled = true;
      apply.textContent = ctx.isApplied ? 'Updating…' : 'Adding…';

      writeParentEngravingProperties(ctx.parentLineIndex, ctx.parentLineQuantity, ctx.engravingTitle, ctx.engravingPrice, orientation, font, value, parentProps)
        .then(function () {
          /* On update: pre-existing child engraving line may already exist with stale values — remove it before re-adding. */
          if (ctx.isApplied) {
            return removeChildEngravingLine(ctx.engravingTitle, ctx.parentTitle);
          }
        })
        .then(function () {
          return addChildEngravingLine(ctx.engravingVariantId, ctx.parentLineQuantity, ctx.parentTitle, orientation, font, value);
        })
        .then(function () { return refreshCartDrawer(section); })
        .then(function () { closeEngravingModal(section); })
        .catch(function (err) {
          apply.disabled = false;
          apply.textContent = ctx.isApplied ? 'Update Engraving' : 'Apply Engraving';
          errorEl.textContent = (err && err.message) || 'Could not apply engraving. Please try again.';
          errorEl.style.display = '';
        });
    });
    actions.appendChild(apply);

    if (ctx.isApplied) {
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'oddit-cart-drawer__engraving-apply';
      remove.style.backgroundColor = '#ffffff';
      remove.style.color = '#1c1d1d';
      remove.style.border = '1.5px solid #1c1d1d';
      remove.textContent = 'Remove';
      remove.addEventListener('click', function () {
        remove.disabled = true;
        remove.textContent = 'Removing…';
        rebuildParentWithoutEngraving(parentLine, ctx.engravingTitle)
          .then(function () { return removeChildEngravingLine(ctx.engravingTitle, ctx.parentTitle); })
          .then(function () { return refreshCartDrawer(section); })
          .then(function () { closeEngravingModal(section); })
          .catch(function () {
            remove.disabled = false;
            remove.textContent = 'Remove';
          });
      });
      actions.appendChild(remove);
    }

    content.appendChild(actions);
  }

  function writeParentEngravingProperties(lineIndex, quantity, engravingTitle, engravingPrice, orientation, font, text, currentProps) {
    /* Preserve every non-engraving property already on the parent line so
       unrelated upcharges (e.g. bolt/clip "{title}: {price}") aren't lost
       when /cart/change.js replaces the property bag. */
    var properties = {};
    var ENGRAVING_SYSTEM_KEYS = ['_parent_product', '-Orientation', '-Font selection', '-Engraving text'];
    if (currentProps) {
      Object.keys(currentProps).forEach(function (key) {
        if (ENGRAVING_SYSTEM_KEYS.indexOf(key) !== -1) return;
        if (engravingTitle && key === engravingTitle) return;
        properties[key] = currentProps[key];
      });
    }
    properties['_parent_product'] = 'true';
    properties['-Orientation'] = orientation;
    properties['-Font selection'] = font;
    properties['-Engraving text'] = text;
    /* Engraving title key with the formatted price as value — surfaces the upcharge in cart UI. */
    if (engravingTitle) properties[engravingTitle] = engravingPrice || '';
    return changeLineProperties(lineIndex, quantity, properties);
  }

  function clearParentEngravingProperties(lineIndex, quantity, currentProps) {
    /* Preserve any properties that aren't engraving-related so we don't trample
       unrelated metadata. */
    var kept = {};
    var ENGRAVING_KEYS = ['_parent_product', '-Orientation', '-Font selection', '-Engraving text'];
    Object.keys(currentProps || {}).forEach(function (key) {
      if (ENGRAVING_KEYS.indexOf(key) !== -1) return;
      /* Property keyed by the engraving product title (e.g. "Clip Engraving": "$10")
         is the surfaced upcharge — drop it too. We can't know that title generically
         here, but values that look like a money string keyed by a non-system key
         are very likely the surfaced upcharge. To stay safe and predictable, we drop
         any non-system property whose value looks like a price. */
      var value = currentProps[key];
      if (typeof value === 'string' && /^\$[\d,.]+$/.test(value)) return;
      kept[key] = value;
    });
    return changeLineProperties(lineIndex, quantity, kept);
  }

  /* Shopify's /cart/change.js does not reliably clear properties on an existing
     line item — passing `properties: {}` is a no-op in some configurations. To
     guarantee removal of the engraving values, we delete the parent line by its
     line key and re-add it with only the non-engraving properties. The cart
     visually moves the line to the end, but properties are deterministically clean. */
  function rebuildParentWithoutEngraving(parentLine, engravingTitle) {
    if (!parentLine || !parentLine.key || !parentLine.variant_id) {
      return Promise.reject(new Error('Missing parent line info'));
    }
    var keptProperties = {};
    var ENGRAVING_KEYS = ['_parent_product', '-Orientation', '-Font selection', '-Engraving text'];
    Object.keys(parentLine.properties || {}).forEach(function (key) {
      if (ENGRAVING_KEYS.indexOf(key) !== -1) return;
      /* Drop only the engraving title's surfaced upcharge property; leave
         every other "{title}: {price}" key (e.g. bolt/clip add-ons) intact. */
      if (engravingTitle && key === engravingTitle) return;
      keptProperties[key] = parentLine.properties[key];
    });

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parentLine.key, quantity: 0 })
    }).then(function (res) {
      if (!res.ok) throw new Error('Could not remove parent line');
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: parentLine.variant_id,
          quantity: parentLine.quantity,
          properties: keptProperties
        })
      });
    }).then(function (res) {
      if (!res.ok) throw new Error('Could not re-add parent line');
      return res.json();
    });
  }

  function changeLineProperties(lineIndex, quantity, properties) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: quantity, properties: properties })
    }).then(function (res) {
      return res.json().then(function (body) {
        if (!res.ok) throw new Error((body && (body.description || body.message)) || 'Cart change failed');
        return body;
      });
    });
  }

  function addChildEngravingLine(engravingVariantId, quantity, parentTitle, orientation, font, text) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: engravingVariantId,
        quantity: quantity,
        properties: {
          '_child_product': 'true',
          '_parent_product': parentTitle,
          '-Orientation': orientation,
          '-Font selection': font,
          '-Engraving text': text
        }
      })
    }).then(function (res) {
      return res.json().then(function (body) {
        if (!res.ok) throw new Error((body && (body.description || body.message)) || 'Add engraving failed');
        return body;
      });
    });
  }

  function removeChildEngravingLine(engravingTitle, parentTitle) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        for (var i = 0; i < cart.items.length; i++) {
          var ci = cart.items[i];
          if (
            ci.product_title === engravingTitle &&
            ci.properties &&
            ci.properties._child_product &&
            ci.properties._parent_product === parentTitle
          ) {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: ci.key, quantity: 0 })
            }).then(function (res) {
              if (!res.ok) throw new Error('Could not remove engraving line');
              return res.json();
            });
          }
        }
      });
  }

  /* Find any engraving (child) lines whose parent product is no longer in the cart
     and remove them. Also sync child quantities to match their parent. */
  function syncChildEngravings() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        var children = [];
        var parentsByTitle = {};
        cart.items.forEach(function (ci) {
          if (ci.properties && ci.properties._child_product) {
            children.push(ci);
          } else {
            parentsByTitle[ci.product_title] = ci;
          }
        });
        var ops = [];
        children.forEach(function (child) {
          var parentTitle = child.properties && child.properties._parent_product;
          var parent = parentTitle ? parentsByTitle[parentTitle] : null;
          var desiredQty = parent ? parent.quantity : 0;
          if (child.quantity !== desiredQty) {
            ops.push({ id: child.key, quantity: desiredQty });
          }
        });
        return ops.reduce(function (chain, op) {
          return chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(op)
            });
          });
        }, Promise.resolve());
      });
  }

  function buildOrientationSection(initial, onChange) {
    var section = document.createElement('div');
    section.className = 'oddit-cart-drawer__engraving-section';

    var label = document.createElement('p');
    label.className = 'oddit-cart-drawer__engraving-section-label';
    label.textContent = 'Orientation*';
    section.appendChild(label);

    var row = document.createElement('div');
    row.className = 'oddit-cart-drawer__engraving-orientation';

    ['Right Handed', 'Left Handed'].forEach(function (val) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'oddit-cart-drawer__engraving-radio';
      if (val === initial) btn.classList.add('is-selected');

      var dot = document.createElement('span');
      dot.className = 'oddit-cart-drawer__engraving-radio-dot';
      btn.appendChild(dot);

      var text = document.createElement('span');
      text.textContent = val;
      btn.appendChild(text);

      btn.addEventListener('click', function () {
        row.querySelectorAll('.oddit-cart-drawer__engraving-radio').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        onChange(val);
      });

      row.appendChild(btn);
    });

    section.appendChild(row);
    return section;
  }

  /* A value is available if some variant has options[optionIdx] = value AND
     matches all OTHER currently-selected options AND is itself available. */
  function isOptionValueAvailable(variants, optionIdx, value, selectedOptions) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (!v.available) continue;
      if (v.options[optionIdx] !== value) continue;
      var otherMatch = true;
      for (var j = 0; j < selectedOptions.length; j++) {
        if (j === optionIdx) continue;
        if (v.options[j] !== selectedOptions[j]) { otherMatch = false; break; }
      }
      if (otherMatch) return true;
    }
    return false;
  }

  function findVariantByOptions(variants, options) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < options.length; j++) {
        if (v.options[j] !== options[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function addVariantToCart(variantId, quantity, properties) {
    var body = { id: variantId, quantity: quantity || 1 };
    if (properties && Object.keys(properties).length > 0) {
      body.properties = properties;
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    }).then(function (added) {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          return added;
        });
    });
  }

  function variantImageSrc(variant) {
    if (!variant) return null;
    var img = variant.featured_image;
    if (!img) return null;
    if (typeof img === 'string') return img;
    return img.src || null;
  }

  function refreshCartDrawer(section) {
    if (!section || !section.id) return Promise.resolve();
    return fetch('/?section_id=' + encodeURIComponent(section.id))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var newRoot = temp.querySelector('.oddit-cart-drawer');
        if (!newRoot) return;

        var oldContent = section.querySelector('.oddit-cart-drawer__content');
        var newContent = newRoot.querySelector('.oddit-cart-drawer__content');
        if (oldContent && newContent) {
          oldContent.innerHTML = newContent.innerHTML;
          /* Reveals are normally activated by IntersectionObserver in
             oddit-interactions.js. Newly inserted nodes aren't observed,
             so they'd stay opacity:0. Anything inside the open drawer is
             already in view — mark it visible immediately. */
          oldContent.querySelectorAll('.oddit-reveal').forEach(function (el) {
            el.classList.add('is-visible');
          });
        }

        var oldCount = section.querySelector('[data-cart-total-items]');
        var newCount = newRoot.querySelector('[data-cart-total-items]');
        if (oldCount && newCount) {
          oldCount.textContent = newCount.textContent;
          /* Mirror the visible-product count to the header cart badge so it stays in sync.
             The drawer's count strips the surrounding parens (e.g. "(2)" -> "2") and
             toggles visibility based on whether anything's in the cart. */
          var headerBadges = document.querySelectorAll('.oddit-header__cart-count[data-cart-count]');
          if (headerBadges.length) {
            var raw = newCount.textContent.replace(/[^\d]/g, '');
            var n = parseInt(raw, 10) || 0;
            headerBadges.forEach(function (badge) {
              badge.textContent = n;
              badge.style.display = n > 0 ? '' : 'none';
            });
          }
        }

        var oldFooter = section.querySelector('[data-cart-footer]');
        var newFooter = newRoot.querySelector('[data-cart-footer]');
        if (oldFooter && newFooter) {
          oldFooter.innerHTML = newFooter.innerHTML;
          if (newFooter.hasAttribute('hidden')) {
            oldFooter.setAttribute('hidden', '');
          } else {
            oldFooter.removeAttribute('hidden');
          }
        }
      })
      .catch(function () {});
  }

  function formatMoney(cents) {
    /* Shopify returns prices in cents. Use shop's money format if exposed. */
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.Shopify.money_format) {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  /* Theme editor open-state preservation.
     When a setting/block changes inside a cart drawer section, Shopify replaces
     the section HTML — the new markup has no `is-open`, so the drawer appears
     to close. We mirror the open state through sessionStorage across the
     unload/load pair so it survives the section refresh. Storefront usage
     ignores this branch entirely. */
  var EDITOR_OPEN_KEY_PREFIX = 'oddit-cart-drawer-editor-open:';

  function rememberEditorOpenState(section) {
    if (!isThemeEditor()) return;
    if (section.classList.contains('oddit-cart-drawer--page')) return;
    var sectionId = section.id;
    if (!sectionId) return;
    if (section.classList.contains('is-open')) {
      try { sessionStorage.setItem(EDITOR_OPEN_KEY_PREFIX + sectionId, '1'); } catch (e) {}
    }
  }

  function restoreEditorOpenState(section) {
    if (!isThemeEditor()) return;
    if (section.classList.contains('oddit-cart-drawer--page')) return;
    var sectionId = section.id;
    if (!sectionId) return;
    var key = EDITOR_OPEN_KEY_PREFIX + sectionId;
    try {
      if (sessionStorage.getItem(key) === '1') {
        sessionStorage.removeItem(key);
        openDrawer(section);
      }
    } catch (e) {}
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(function (section) {
    initSection(section);
    restoreEditorOpenState(section);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) {
      initSection(section);
      restoreEditorOpenState(section);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    /* The unloading wrapper is `<div id="shopify-section-{sectionId}">`. The
       drawer originally inside it has `id="{sectionId}"` and may have been
       portaled to <body>, so it's no longer a descendant of the wrapper. Look
       it up by id from our portaled map first; otherwise fall back to a
       descendant query. */
    var wrapperId = (e.target && e.target.id) || '';
    var sectionId = wrapperId.replace(/^shopify-section-/, '');
    var section = sectionId ? portaledDrawers.get(sectionId) : null;
    if (!section && e.target.querySelector) {
      section = e.target.querySelector(SECTION_SELECTOR);
    }
    if (section) {
      rememberEditorOpenState(section);
      destroySection(section);
      if (sectionId) {
        portaledDrawers.delete(sectionId);
      }
      if (section.parentElement) {
        section.parentElement.removeChild(section);
      }
    }
  });

  window.OdditCartDrawer = {
    open: function () {
      var section = document.querySelector(SECTION_SELECTOR);
      if (section) openDrawer(section);
    },
    close: function () {
      var section = document.querySelector(SECTION_SELECTOR);
      if (section) closeDrawer(section);
    },
    toggle: function () {
      var section = document.querySelector(SECTION_SELECTOR);
      if (!section) return;
      if (section.classList.contains('is-open')) {
        closeDrawer(section);
      } else {
        openDrawer(section);
      }
    },
    addToCart: function (variantId, quantity, properties) {
      var section = document.querySelector(SECTION_SELECTOR);
      return addVariantToCart(variantId, quantity, properties).then(function (result) {
        if (section) {
          return refreshCartDrawer(section).then(function () { return result; });
        }
        return result;
      });
    },
    quickAdd: function (handle) {
      var section = document.querySelector(SECTION_SELECTOR);
      if (!section || !handle) return;
      // Reveal section so the modal can render. The drawer panel itself
      // stays translated off-screen because we don't add `is-open`. This
      // class enables pointer-events on the section and clears its inline
      // display:none so the modal (a sibling of the panel) is visible.
      if (!section.classList.contains('is-open')) {
        section.style.display = '';
        section.classList.add('is-quick-add-only');
      }
      var fakeTrigger = document.createElement('button');
      fakeTrigger.setAttribute('data-product-handle', handle);
      openQuickAddModal(section, fakeTrigger);
    }
  };
})();